import styled from 'styled-components'
import { Image as BoltImage } from '@sainsburys-tech/bolt'

const Heading = styled.h2`
  && {
    font-size: ${props => props.theme.font.size['display-1']};
    font-weight: ${props => props.theme.font.weight.bold};
    margin-bottom: ${props => props.theme.size.spacing.xl};
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.size.spacing.xl};
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    flex-direction: row;
    gap: ${props => props.theme.size.spacing['2xl']};
  }
`

const ProductContainer = styled.div``

const FormContainer = styled.div`
  flex: 1;
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    padding-top: ${props => props.theme.size.spacing.xl};
  }
`

const ProductTitle = styled.h4`
  font-size: ${props => props.theme.font.size['display-3']};
  font-weight: ${props => props.theme.font.weight.bold};
  margin-bottom: ${props => props.theme.size.spacing.md};
`

const ImageWrapper = styled.div`
  display: flex;
`

const Image = styled(BoltImage)`
  width: 100%;
`

export { Heading, Content, ProductContainer, FormContainer, ProductTitle, ImageWrapper, Image }
